import { memo } from 'react';
import { Bot } from 'lucide-react';
import type { NodeProps } from '@xyflow/react';
import type { ComposerNodeData } from '../../../types/composer';
import { ComposerNodeCard } from './ComposerNodeCard';

export const AgentNode = memo((props: NodeProps) => (
  <ComposerNodeCard
    {...props}
    data={props.data as ComposerNodeData}
    typeName="agent"
    glyph={<Bot size={14} strokeWidth={2.2} />}
  />
));

AgentNode.displayName = 'AgentNode';
